<form novalidate [formGroup]="formGroup">
  <mat-form-field>
    <mat-select
      [placeholder]="inputInformation.data?.placeholder"
      (click)="onFormChange($event, formGroup)"
      [formControlName]="inputInformation.updateKey"
    >
      <mat-option
        *ngFor="let option of inputInformation.data?.options"
        [value]="option.value"
      >
        <span i18n="@@settingsView.selectOption">{option.text, select,
          other {{{ option.text }}}
        }</span>
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
